import React, { useEffect } from "react";
import { connect } from "react-redux";
import { saveUser } from "../../redux/actions/userAction";
import { saveProducts } from "../../redux/actions/productsAction";
import ImageMapper from 'react-img-mapper';
import { useHistory } from "react-router-dom";
import HeroSliderOneNew from "../../backconfig/banner/HeroSliderOneNew";
import BannerClassicScroll from "./BannerClassicScroll";
import { useState } from "react";
import BannerAmazonStyle from "./BannerAmazonStyle";

const HomeBanner = (props) => {
  const history = useHistory();
  const { userData, bannerProps, forTestOnly, products } = props;
  const isLoggedUser = (((userData?.user?.user) && (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge))) ? true : false;
  
  const [bannerNow, setBannerNow] = useState(forTestOnly ? bannerProps : bannerProps || (isLoggedUser ? window['bannerHome'] : window['bannerHomeNoLog']));

  useEffect(() => {
    setBannerNow(forTestOnly ? bannerProps : bannerProps || (isLoggedUser ? window['bannerHome'] : window['bannerHomeNoLog']));
  }, [forTestOnly, bannerProps, isLoggedUser])
 
  const clickMapBanner = (area, index, event) => {
    if (!area?.navigateTo) return;
    history.push(area.navigateTo + (area.qString ? area.qString : ''));
  }

  const getBanner = () => {
    const _props = {heroSliderData : bannerNow.bannerImageScroll, forTestOnly, userData, products };
    //return (<BannerAmazonStyle {..._props} products = {products}/>);

    switch (bannerNow.bannerType) {
      case 1:  return (<HeroSliderOneNew {..._props}/>);
      case 2:  return (<BannerClassicScroll {..._props} />);
      default: return null;
    }
  }

  if (bannerNow) {
    const n = getBanner();
    if (n)
      return n;
    else
      if (forTestOnly) return null;
  }
  /*<!-- Image Map Generated by http://www.image-map.net/ -->
<img src="newbanner1conprezzo.png" usemap="#image-map">

<map name="image-map">
    <area target="" alt="" title="" href="" coords="1,3,1578,1,
                                                1465,534,1,534" shape="poly">
    <area target="" alt="" title="" href="" coords="1,539,1465,537, 1379,
                                                953,1,953,1,762" shape="poly">
    <area target="" alt="" title="" href="" coords=
        "2248,954,1495,956,1580,530, 1580,
        23,1680,21,1686,-1,2248,3" shape="poly">
</map>
*/

  const jRouteParams = {
    "brands": ['JHK', 'VALENTO'],
    "category": ["GILET"],
    "subcategory": ["ALTA VISIBILITA'"],
    "templates": ["MANICA CORTA", "MANICA LUNGA", "CANOTTA"]
  };
  const jM1 = [
    {
      //"qString": new URLSearchParams({ "brands": ['JHK', 'VALENTO'], "category": ["GILET"], "subcategory": ["ALTA VISIBILITA'"], "templates": ["MANICA CORTA", "MANICA LUNGA", "CANOTTA"] }).toString(),
      //"navigateTo": "/shop-grid-full-width/",
      "navigateTo": "/product/112316",
      "id": "469f9800-c45a-483f-b13e-bd24f3fb79f4",
      "title": "Hardwood",
      "shape": "poly",
      "name": "1",
      "fillColor": "#eab54d4d",
      "strokeColor": "black",
      "coords": [0, 0, 1120, 0, 1041, 379, 0, 379],
      "polygon": [[0, 0], [1120, 0], [1041, 379], [0, 379]]
    },
    {
      "qString": new URLSearchParams({ "tag": ["TOTAL MATCH"] }).toString(),
      //"qString": new URLSearchParams(jRouteParams).toString(),
      "navigateTo": "/shop-grid-full-width/",
      "id": "469f9800-c45a-483f-b13e-bd24f3fb79f5",
      "title": "Hardwood2",
      "shape": "poly",
      "name": "1",
      "fillColor": "#eab54d4d",
      "strokeColor": "black",
      "coords": [0, 382, 1043, 382, 977, 705, 0, 705, 0, 564],
      "polygon": [[0, 382], [1043, 382], [977, 705], [0, 705], [0, 564]]
    },
    {
      "navigateTo": "/product/114950",
      "id": "469f9800-c45a-483f-b13e-bd24f3fb79f6",
      "title": "Hardwood2",
      "shape": "poly",
      "name": "1",
      "fillColor": "#eab54d4d",
      "strokeColor": "black",
      "coords": [1663, 680, 1060, 705, 1124, 378, 1124, 16, 1195, 16, 1198, 0, 1600, 0],
      "polygon": [[1663, 680], [1060, 705], [1124, 378], [1124, 16], [1195, 16], [1198, 0], [1600, 0]]
    }
  ]
  const jM2 = [
    {
      "qString": new URLSearchParams({ "brands": ['FRUIT'], "category": ["FELPA "] }).toString(),
      //"qString": new URLSearchParams(jRouteParams).toString(),
      "navigateTo": "/shop-grid-full-width/",
      "id": "469f9800-c45a-483f-b13e-bd24f3fb79f5",
      "title": "Hardwood2",
      "shape": "poly",
      "name": "1",
      "fillColor": "#eab54d4d",
      "strokeColor": "black",
      "coords": [0, 382, 1043, 382, 977, 705, 0, 705, 0, 564],
      "polygon": [[0, 382], [1043, 382], [977, 705], [0, 705], [0, 564]]
    },
    {
      "navigateTo": "/product/114950",
      "id": "469f9800-c45a-483f-b13e-bd24f3fb79f6",
      "title": "Hardwood2",
      "shape": "poly",
      "name": "1",
      "fillColor": "#eab54d4d",
      "strokeColor": "black",
      "coords": [1663, 680, 1060, 705, 1124, 378, 1124, 16, 1195, 16, 1198, 0, 1600, 0],
      "polygon": [[1663, 680], [1060, 705], [1124, 378], [1124, 16], [1195, 16], [1198, 0], [1600, 0]]
    },
    {
      //"qString": new URLSearchParams({ "brands": ['FRUIT'], "category": ["FELPA "] }).toString(),
      //"qString": new URLSearchParams(jRouteParams).toString(),
      "navigateTo": "/product/98261",
      "id": "469f9800-c45a-483f-b13e-bd24f3fb79f5",
      "title": "Hardwood2",
      "name": "1",
      "fillColor": "#eab54d4d",
      "strokeColor": "black",
      "coords": [3, 0, 309, 379],
      "shape": "rect"
    },
    {
      //"qString": new URLSearchParams({ "brands": ['FRUIT'], "category": ["FELPA "] }).toString(),
      //"qString": new URLSearchParams(jRouteParams).toString(),
      "navigateTo": "/product/114950",
      "id": "469f9800-c45a-483f-b13e-bd24f3fb79f5",
      "title": "Hardwood2",
      "shape": "poly",
      "name": "1",
      "fillColor": "#eab54d4d",
      "strokeColor": "black",
      "coords": [742, 0, 742, 379, 1041, 379, 1120, 0],
      "shape": "poly"
    },
  ]


  return (
    <div
      className={`single-slider slider-height-1 bg-white`}
    >

      <div className="container">
        <div className="row">
          <div className="slider-content slider-animated-1">
            <div className="slider-single-img slider-animated-1" >
              <div className="slider-single-img slider-animated-1" >
                <div style={{ height: 500 }} id="loading">
                  <img style={{ position: "absolute", margin: "auto", top: 0, left: 0, right: 0, bottom: 0 }} src="https://www.istitutomarangoni.com/fe-web/img/marangoni/loader.gif" />
                </div>
                <ImageMapper
                  onLoad={() => document.getElementById("loading").style.display = "none"}
                  onClick={(area, index, event) => clickMapBanner(area, index, event)}
                  width={1600}
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    width: 'auto'
                  }}
                  src={(((userData.user.user) && (userData.user.user.IDCli))) ? "/assets/img/newBanner/maggioConPrezzo.png" : "/assets/img/newBanner/maggioSenzaPrezzo.png"}
                  alt=""
                  map={{
                    name: 'my-map',
                    areas: jM1
                  }}
                />
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

  );
};

const mapStateToProps = state => {
  return {
    userData: state.userData,
    products: state.productData.products,
  };
};

const mapDispatchToProps = dispatch => {

  return {
    saveUser: (user, addToast) => { dispatch(saveUser(user, addToast)) },
    saveProducts: (products, addToast) => { dispatch(saveProducts(products, addToast)) }

  };
};
export default connect(mapStateToProps, mapDispatchToProps)(HomeBanner);